import { createFileRoute } from "@tanstack/react-router";
import { type AgentLocation, AgentWorkspace } from "@/features/evals/AgentWorkspace";
export const Route = createFileRoute("/_authenticated/agents")({
  staticData: { access: { anyOf: ["agents.manage"] } },
  validateSearch: (search: Record<string, unknown>): AgentLocation => ({
    agentId: typeof search.agentId === "string" ? search.agentId : undefined,
    versionId: typeof search.versionId === "string" ? search.versionId : undefined,
    role: search.role === "player" || search.role === "grader" ? search.role : "gameMaster",
    draft: search.draft === true || search.draft === "true" || undefined,
  }),
  head: () => ({ meta: [{ title: "Agents · Pax.co" }] }),
  component: Page,
});
function Page() {
  const location = Route.useSearch();
  const navigate = Route.useNavigate();
  return <AgentWorkspace location={location} navigate={search => void navigate({ search })} />;
}
